<template>
  <div class="col s12 zprstate-page">
    <div class="row">
      <div class="col s12">
        <div class="section no-padding">
          <h5>Axlecounter</h5>
          <p>ZPR State</p>
        </div>
        <div class="divider"></div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <p v-show="ZPRStateItems.length === 0">No ZPR states available</p>
        <table class="striped" v-show="ZPRStateItems.length !== 0">
          <thead>
            <tr>
              <th>Last measurement</th>
              <th>ZPR</th>
              <th>1 Fbits</th>
              <th>2 Fbits</th>
              <th>3 Fbits</th>
              <th>4 Fbits</th>
              <th>Drift</th>
              <th>SQP</th>
              <th>Tel %</th>
              <th>State</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in ZPRStateItems" v-bind:key="index"
              v-show="index + 1 <= (paging.itemsPerPage * paging.selectedPage) &&
              index + 1 > ((paging.itemsPerPage * paging.selectedPage) -paging.itemsPerPage)">
              <td>{{ formatDateTime(item.DateTimeChanged) }}</td>
              <td>{{ item.Zpr }}</td>
              <td>{{ item.Fbits1 }}</td>
              <td>{{ item.Fbits2 }}</td>
              <td>{{ item.Fbits3 }}</td>
              <td>{{ item.Fbits4 }}</td>
              <td>{{ item.Drift }}</td>
              <td>{{ item.ShortWheelPulse }}</td>
              <td>{{ item.Tfr }}</td>
              <td>{{ $t(statusToText(item.Status)) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <ul class="pagination center-align" v-if="paging.enabled && ZPRStateItems.length > 0">
          <li
            :class="{ disabled: paging.selectedPage === 1, 'waves-effect': paging.selectedPage > 1 }"
            @click="paging.selectedPage !== 1 && paging.selectedPage--">
            <i class="material-icons">chevron_left</i>
          </li>

          <li
            v-for="(pageNumber, index) in paging.numberOfPages" v-bind:key="index"
            class="waves-effect"
            :class="{ active: paging.selectedPage == pageNumber }"
            @click="paging.selectedPage = pageNumber"
          >
            <a>{{ pageNumber }}</a>
          </li>

          <li :class="{ disabled: paging.selectedPage === paging.numberOfPages, 'waves-effect': paging.selectedPage < paging.numberOfPages }"
            @click="paging.selectedPage !== paging.numberOfPages && paging.selectedPage++">
            <i class="material-icons">chevron_right</i>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <div class="divider" style="margin-bottom: 12px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AxleCounterService from '@/services/AxleCounterService'
import moment from 'moment'

export default {
  data () {
    return {
      ZPRStateItems: [],
      paging: {
        enabled: true,
        itemsPerPage: 15,
        numberOfPages: 0,
        selectedPage: 1,
        chevronLeftActive: false,
        chevronRightActive: false
      },
      maxRows: {
        startFrom: 0,
        nrOfRows: 100
      }
    }
  },
  mounted: function () {
    this.getZprstate()
  },
  watch: {
    '$route.params.railobjectid': {
      handler: function (val, oldVal) {
        this.getZprstate()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getZprstate: function () {
      this.ZPRStateItems = []
      AxleCounterService.GetZprStateByRailobjectId(this.$route.params.railobjectid, this.maxRows.startFrom, this.maxRows.nrOfRows).then(result => {
        this.ZPRStateItems = result.data
      }).then(() => {
        this.setPagingParameters()
      })
    },
    setPagingParameters: function () {
      this.paging.selectedPage = 1
      this.paging.numberOfPages = Math.ceil(this.ZPRStateItems.length / this.paging.itemsPerPage)
    },
    statusToText (status) {
      if (status === 1003) return 'axlecounter.statusFailed'
      if (status === 1002) return 'axlecounter.statusWarning'
      if (status === 1001) return 'axlecounter.statusUnknown'
      if (status === 1000) return 'axlecounter.statusOK'
      else return 'axlecounter.statusUnknown'
    },
    formatDateTime: (dateTime) => {
      return moment(String(dateTime)).format('DD-MM-YYYY HH:mm')
    }
  }
}

</script>

<style scoped>
.zprstate-page {
  overflow-y: auto;
  height: 84vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/axlecounter/_zprState.vue